// src/App.js
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { BrowserRouter, Navigate } from "react-router-dom";
import Sidebar from "./components/Layout/Sidebar/Sidebar";
import Navbar from "./components/Layout/Navbar/Navbar";
import Footer from "./components/Layout/Footer/Footer";
import AppRoutes from "./Routes/AppRoute";
import Login from "./Pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  const context = useContext(AuthContext);

  if (!context) {
    console.error(
      "AuthContext is not available. Ensure App is wrapped with AuthProvider."
    );
    return <div>Error: AuthContext not found</div>;
  }

  const { user, isLoading } = context;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        {user ? (
          <>
            <Sidebar />
            <Navbar />
            <main>
              <AppRoutes />
            </main>
            <Footer />
          </>
        ) : (
          <Login />
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
